import { Pipe, PipeTransform } from "@angular/core";

/* A pure pipe to generate a random color based on the userId passed in */
@Pipe({
  name: "badgeColor",
  standalone: false
})
export class BadgeColorPipe implements PipeTransform {
  transform(userId: string | null | undefined): string {
    if (!userId) {
      return "hsl(0, 0%, 70%)";
    }

    let hash = 0;

    for (let i = 0; i < userId.length; i++) {
      hash = userId.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;

    return `hsl(${hue}, 60%, 45%)`;
  }
}
